import {CostumResponse} from '../Dashboard/DashboardResponse'
export default class   VideoIntroResponse {
    constructor(
    public response?: CostumResponse  ,
    public data? : MostrarIntro[]  
    ){}
}

class   MostrarIntro {
    constructor(
    public mostrarIntro?: boolean

    ){}
}

export {VideoIntroResponse,MostrarIntro}